import { render, staticRenderFns } from "./folder-scenario-dialog.vue?vue&type=template&id=1fb10639"
import script from "./folder-scenario-dialog.vue?vue&type=script&lang=ts"
export * from "./folder-scenario-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports